"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Base = _interopRequireDefault(require("ol/layer/Base"));

var _State = _interopRequireDefault(require("ol/source/State"));

var _antd = require("antd");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOpts = function getOpts(layer) {
  if (layer instanceof _Base.default) {
    var sourceOpts = {
      source: {
        url: layer.getSource().getUrls(),
        attributions: layer.getSource().getAttributions() && layer.getSource().getAttributions()(_State.default.READY),
        params: {
          FEATURE_COUNT: layer.getSource().getParams().FEATURE_COUNT,
          FORMAT: layer.getSource().getParams().FORMAT,
          LAYERS: layer.getSource().getParams().LAYERS,
          STYLES: layer.getSource().getParams().STYLES,
          VERSION: layer.getSource().getParams().VERSION,
          CQL_FILTER: layer.getSource().getParams().CQL_FILTER
        }
      }
    };
    return sourceOpts;
  }
};

var TileWMSSourceTab = function TileWMSSourceTab(_ref) {
  var mode = _ref.mode;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.default.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: ['source', 'url'],
      label: "URL",
      rules: [{
        required: true
      }],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Input, {})
    }),
    /*#__PURE__*/

    /* Attributions */
    (0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: ['source', 'attributions'],
      label: "Attributions",
      rules: [{
        required: false
      }],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Input, {})
    }),
    /* Cache Size  */
    mode === "new" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: ['source', 'cacheSize'],
      label: "Cache Size",
      rules: [{
        required: false
      }],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.InputNumber, {})
    }),
    /* Cross-Origin */
    mode === "new" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: ['source', 'crossOrigin'],
      label: "Cross Origin",
      rules: [{
        required: false
      }],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Input, {})
    }),
    /* Image Smoothing */
    mode === "new" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: ['source', 'imageSmoothing'],
      label: "Image Smooth.: ",
      valuePropName: "checked",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Checkbox, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: ['source', 'params', 'FEATURE_COUNT'],
      label: "Feature Count" // rules={[
      //     {
      //         required: true,
      //     },
      // ]}
      ,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.InputNumber, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: ['source', 'params', 'FORMAT'],
      label: "Format" // rules={[
      //     {
      //         required: true,
      //     },
      // ]}
      ,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Input, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: ['source', 'params', 'LAYERS'],
      label: "Layers",
      rules: [{
        required: true
      }],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Input, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: ['source', 'params', 'STYLES'],
      label: "Styles",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Input, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: ['source', 'params', 'VERSION'],
      label: "Version" // rules={[
      //     {
      //         required: true,
      //     },
      // ]}
      ,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Input, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: ['source', 'params', 'CQL_FILTER'],
      label: "CQL Filter",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Input.TextArea, {
        allowClear: true
      })
    }),
    /* Gutter */
    mode === "new" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: ['source', 'gutter'],
      label: "Gutter",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.InputNumber, {})
    }),
    /* hidpi */
    mode === "new" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: ['source', 'hidpi'],
      label: "hidpi",
      valuePropName: "checked",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Checkbox, {})
    }),
    /* Maximum Zoom */
    mode === "new" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: ['source', 'maxZoom'],
      label: "Max Zoom",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.InputNumber, {})
    }),
    /* Reprojection Error Threshold */
    mode === "new" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: ['source', 'reprojectionErrorThreshold'],
      label: "Reproj. Error Threshold",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.InputNumber, {})
    }),
    /* Server Type */
    mode === "new" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: ['source', 'serverType'],
      label: "Server Type",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Input, {})
    }),
    /* Wrap X */
    mode === "new" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: ['source', 'wrapX'],
      label: "Wrap X",
      valuePropName: "checked",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Checkbox, {})
    }),
    /* Transition */
    mode === "new" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: ['source', 'transition'],
      label: "Transition",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.InputNumber, {})
    })]
  });
};

TileWMSSourceTab.getOpts = getOpts;
var _default = TileWMSSourceTab;
exports.default = _default;